export default __webpack_public_path__ + "static/media/smart_cap.115b4956.svg";